import { FreightMode } from '@freight-cbm/shared-types';
import { useAppStore } from '@/store/store';

const modes: { key: FreightMode; label: string; divisor: number; hint: string }[] = [
  { key: FreightMode.Air, label: 'Air', divisor: 6000, hint: 'Standard air freight. DIM weight = volume (cm³) ÷ 6000.' },
  { key: FreightMode.OceanLCL, label: 'Ocean LCL', divisor: 1000, hint: 'Less-than-container-load ocean. Billed per revenue ton (CBM or metric ton, whichever is greater).' },
  { key: FreightMode.Courier, label: 'Courier', divisor: 5000, hint: 'Express courier. DIM weight = volume (cm³) ÷ 5000.' },
];

export function FreightModeSelector() {
  const mode = useAppStore((s) => s.mode);
  const setMode = useAppStore((s) => s.setMode);

  return (
    <div
      role="group"
      aria-label="Freight mode"
      style={{ display: 'flex', gap: 'var(--space-2)' }}
    >
      {modes.map((m) => (
        <button
          key={m.key}
          className={mode === m.key ? 'btn btn-primary' : 'btn'}
          onClick={() => setMode(m.key)}
          aria-pressed={mode === m.key}
          title={m.hint}
          style={{ flex: 1, flexDirection: 'column', gap: 0, padding: 'var(--space-3) var(--space-2)' }}
        >
          <span style={{ fontWeight: 'var(--font-weight-extrabold)', letterSpacing: '-0.01em', textTransform: 'uppercase', fontSize: 'var(--font-size-xs)' }}>{m.label}</span>
          <span style={{ fontSize: 'var(--font-size-sm)', opacity: 0.75, fontFamily: 'var(--font-family-mono)' }}>
            ÷ {m.divisor}
          </span>
        </button>
      ))}
    </div>
  );
}
